import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const intelOwl = defineConnector({
  identifier: "intelOwl",
  name: "IntelOwl",
  tagLine: "Threat intelligence orchestration",
  logo,
  protocol: "http",
  tags: ["security"],
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.apiToken, scheme: "Token" },
    ]),
  steps: [
    {
      title: "Create an IntelOwl API token",
      items: [
        {
          kind: "markdown",
          content:
            "In IntelOwl, create an API token from your user settings and send it as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your IntelOwl details",
      items: [
        {
          kind: "url",
          label: "IntelOwl base URL",
          required: true,
          placeholder: "https://intelowl.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://intelowl.example.com"}/api/ping`,
  },
  defaultUrlPattern: ({ instanceUrl }) => urlToPattern(instanceUrl),
});
